import React from 'react';
import { Route } from 'react-router-dom';
import IQACManagement from '@/pages/iqac/IQACManagement';

export const iqacRoutes = (
  <React.Fragment>
    <Route path="iqac" element={<IQACManagement />} />
    <Route path="iqac/meetings" element={<IQACManagement />} />
    <Route path="iqac/initiatives" element={<IQACManagement />} />
    <Route path="iqac/feedback" element={<IQACManagement />} />
    <Route path="iqac/aqar" element={<IQACManagement />} />
  </React.Fragment>
);
